import { z } from 'zod';
export const fileListQuerySchema = z.object({
    page: z.coerce.number().int().positive().optional().default(1),
    perPage: z.coerce.number().int().min(1).max(100).optional().default(20),
    parentId: z.coerce.number().int().positive().optional(),
    type: z.enum(['file', 'folder']).optional(),
    filter: z.enum(['all', 'starred', 'shared', 'trash']).optional().default('all'),
    search: z.string().optional(),
    tags: z.string().optional(),
    mimeType: z.string().optional(),
    sortBy: z.enum(['original_name', 'size', 'created_at', 'updated_at']).optional().default('updated_at'),
    sortOrder: z.enum(['asc', 'desc']).optional().default('desc'),
});
export const folderCreateSchema = z.object({
    name: z.string().min(1, 'Klasör adı zorunludur').max(255),
    parentId: z.coerce.number().int().positive().optional(),
    description: z.string().max(1000).optional(),
});
export const fileUpdateSchema = z.object({
    originalName: z.string().min(1).max(255).optional(),
    description: z.string().max(1000).optional().nullable(),
    parentId: z.coerce.number().int().positive().optional().nullable(),
});
export const fileShareSchema = z.object({
    sharedWithType: z.enum(['user', 'group']),
    sharedWithId: z.coerce.number().int().positive('Geçerli bir ID giriniz'),
    role: z.enum(['viewer', 'editor']).optional().default('viewer'),
});
export const fileShareUpdateSchema = z.object({
    role: z.enum(['viewer', 'editor']),
});
export const fileBulkActionSchema = z.object({
    fileIds: z.array(z.coerce.number().int().positive()).min(1, 'En az bir dosya seçmelisiniz'),
    action: z.enum(['move', 'delete', 'restore', 'star', 'unstar']),
    targetParentId: z.coerce.number().int().positive().optional().nullable(),
});
export const fileIdParamSchema = z.object({
    id: z.coerce.number().int().positive('Geçerli bir dosya ID giriniz'),
});
export const fileShareIdParamSchema = z.object({
    id: z.coerce.number().int().positive(),
    shareId: z.coerce.number().int().positive(),
});
//# sourceMappingURL=file.schema.js.map